import type { RequestSummary } from "../api/requests";

function mergeOperation(
  prev: RequestSummary["operation"],
  next: RequestSummary["operation"]
): RequestSummary["operation"] {
  if (!next) return prev;
  return {
    ...prev,
    ...next,
    receiveAmount: next.receiveAmount ?? prev?.receiveAmount,
  };
}

/**
 * Apply a request delta to a list (replace by id, otherwise prepend).
 * Keeps an existing `payerName` when the delta omits it so a status-only SSE
 * event cannot wipe the title back to the "Money request" fallback.
 */
export function upsertRequestInList(
  list: RequestSummary[],
  req: RequestSummary
): RequestSummary[] {
  const idx = list.findIndex((r) => r.requestId === req.requestId);
  if (idx >= 0) {
    const prev = list[idx];
    const next = [...list];
    next[idx] = {
      ...req,
      payerName: req.payerName ?? prev.payerName,
      receiveAmount: req.receiveAmount ?? prev.receiveAmount,
      operation: mergeOperation(prev.operation, req.operation),
    };
    return next;
  }
  return [req, ...list];
}
